import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { FormHeader, IconBtn } from '../../../components';
import { showInsuredInsurancePolicyRequest } from '../../../requests/insured/insuredInsurancePolicies';
import { camelCaseEmptyStringRecursive, scrollToTop } from '../../../services/utils';
import basicInsurancePolicy from '../../InsurancePolicy/basicInsurancePolicy';
import InsurancePolicyInfo from '../../InsurancePolicy/InsurancePolicyInfo';

const InsuredInsurancePolicyShow = ({ match }) => {
  const modelUrl = '/insured/insurance_policies';

  const { id } = match.params;

  const [insurancePolicy, setInsurancePolicy] = useState(basicInsurancePolicy);
  const [isFetching, setIsFetching] = useState(false);
  const [moreData, setMoreData] = useState(false);
  const dispatch = useDispatch();

  const { accountName, active, cancellationDate, policyNumber } = insurancePolicy;

  const canceled = !active && !!cancellationDate;

  const handleBreadcrumb = [
    { key: 1, name: 'Pólizas', href: modelUrl },
    { key: 2, name: 'Detalle de póliza' }
  ];

  const handleShowInsurancePolicy = () => {
    setIsFetching(true);
    showInsuredInsurancePolicyRequest(id, {
      dispatch,
      successCallback: response => setInsurancePolicy(camelCaseEmptyStringRecursive(response.data)),
      callback: () => setIsFetching(false)
    });
  };

  useEffect(scrollToTop, []);
  useEffect(handleShowInsurancePolicy, [moreData]);

  return (
    <>
      {isFetching ? (
        <div className="containerSpinnerLoad" style={{ height: '100%' }}>
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <FormHeader
          handleBreadcrumb={handleBreadcrumb}
          title={`${accountName} - N° ${policyNumber}`}
          titleTag={
            canceled && (
              <IconBtn noBtn variant="danger" className="btn-sm ml-4">
                Póliza cancelada
              </IconBtn>
            )
          }
          formComponent={
            <InsurancePolicyInfo
              userModule="insured"
              modelUrl={modelUrl}
              insurancePolicy={insurancePolicy}
              setMoreData={setMoreData}
            />
          }
        />
      )}
    </>
  );
};

export default InsuredInsurancePolicyShow;
